import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=5262b966&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=5262b966&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262b966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5262b966')) {
      api.createRecord('5262b966', component.options)
    } else {
      api.reload('5262b966', component.options)
    }
    module.hot.accept("./EventDetails.vue?vue&type=template&id=5262b966&scoped=true", function () {
      api.rerender('5262b966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/EventDetails.vue"
export default component.exports